import React from 'react'
import SideBar from '../components/common/SideBar'
import Header from '../components/common/Header'
import SubjectAssignmentsLatest from '../components/course/SubjectAssignmentsLatest'
import { useHistory } from 'react-router-dom'
import MyAssessmentList from '../components/myAssessments/MyAssessmentList'

const MyAssessment = () => {
    const history = useHistory()

    const viewAssignment = (id, action) => {
        console.log("id, action",id, action)
        history.push(`/myassessments/4663/subject/62835/assessment/80984`);
        // props.setIsExamLaunchedToFalse()
        // if (action == "view_appeal") {
        //     setShowAppeal(true);
        // } else {
        //     setShowAppeal(false);
        // }
        // setShowAssignment(true);
        // setAssessmentId(id);
        // setTab("viewAssessment");
        // if (!history.location.pathname.includes("shortCourse")) {
        //     history.push(`/myassessments/4663/subject/62835/assessment/80984`);
        // }
    };

    return (
        <>
            <Header></Header>
            <div className="content-wrapper d-flex flex-wrap">
                <SideBar ></SideBar>
                <div className="sidebar-right">
                    <div className="wrap-box-right">
                        <div className="my-tickets-info-list Tickets-main-wrap">
                            <div className="my-tickets-heading-blk flex-direction mb-4">
                                <h4 className="text-left-align landing-heading heading_color_dynamic">
                                    My <span>Assessments</span>
                                </h4>

                            </div>
                           <MyAssessmentList />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default MyAssessment